import { EcoLabel, Unspsc } from "src/api-service";

// **************************************************************************
// ECO LABEL STATE
// **************************************************************************
export interface EcoLabelState {
    ecoLabel: EcoLabel | null;
    ecoLabels: EcoLabel[];
    ecoLabelsLoading: boolean;
    unspsc: Unspsc[];
    unspscLoading: boolean;
}

export const initialEcoLabelState: EcoLabelState = {
    ecoLabel: null,
    ecoLabels: [],
    ecoLabelsLoading: false,
    unspsc: [],
    unspscLoading: false,
};
